import React from 'react'
const FooterTwo = () => {
  return (
    <footer>
      <p className="footer-p">Powered by WeatherStack </p>
    </footer>
  )
}
export default FooterTwo